import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import {
  monthOptions,
  yearOptions,
} from "../../../dashboardLevelMekanikSA/dasboardLaporanHarianPartByMekanikdanSA/config";
import Api from "../../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import { HttpStatus } from "../../../../../common/Constants";
import SimpleMultiHeaderTable from "../../../../../../modules/SimpleMultiHeaderTable";
import {
  buildExcelRequestBodyStatistikBooking,
  getDaysInMonth,
  groupHeaders,
  mapStatistikBookingToTable,
  tableColumns,
} from "./config";
import { saveAs } from "file-saver";

export default class LaporanStatistikBooking extends Component {
  constructor(props) {
    super(props);
    this.currentYear = Number(moment().format("YYYY"));

    this.state = {
      year: yearOptions.find((item) => item.value === this.currentYear),
      dataTable: [],
      rawData: null,
    };
  }

  componentDidMount() {}

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  fetchData = async () => {
    const { onTriggerLoading, search } = this.props;
    const { year } = this.state;

    if (!search) return;
    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanStatistikBooking,
      menuName: "Dashboard Kabeng Keatas - Laporan Statistik Booking",
      args: {
        listCabang: search,
        year: year?.value,
      },
    });

    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataTable: mapStatistikBookingToTable(res.data.data),
        rawData: res.data.data,
      });
    }
  };

  handleSearch = () => {
    this.fetchData();
  };

  handlePrint = async () => {
    const { month, year, dataTable, rawData } = this.state;
    const { onTriggerLoading, setError } = this.props;

    onTriggerLoading();

    try {
      const reqBody = buildExcelRequestBodyStatistikBooking({
        year: year.value,
        dataTable,
      });

      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT").generateAdvancedExcelFromPayload,
        menuName: "Dashboard Level Kabeng Keatas - Laporan Pendapatan Job",
        setError,
        args: reqBody,
      });

      if (!res?.ok) {
        throw new Error("Response tidak valid");
      }

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, `${reqBody.filename}.xlsx`);
    } catch (error) {
      console.error("Error saat generate Excel:", error);
      if (setError) {
        setError("Gagal generate file Excel");
      }
    } finally {
      onTriggerLoading();
    }
  };

  render() {
    const { year, dataTable } = this.state;
    return (
      <React.Fragment>
        <style>
          {`
          .laporan-full-width .table-container-wrapper,
          .laporan-full-width .table-content-wrapper {
            max-width: none !important;
            width: 100%;
          }
        `}
        </style>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginTop: "5px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <p className="margin-bottom-20px" style={{ fontWeight: "bold" }}>
          LAPORAN STATISTIK BOOKING
        </p>
        <div className="laporan-full-width">
          <SimpleMultiHeaderTable
            data={dataTable}
            columns={tableColumns}
            groupHeaders={groupHeaders}
          />
        </div>
        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton text="CETAK" onClick={this.handlePrint} />
        </FlexView>
      </React.Fragment>
    );
  }
}
